"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.BackButton = void 0;

var _react = _interopRequireDefault(require("react"));

var _Icons = _interopRequireDefault(require("../../baseComponents/Icons"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var BackButton = function BackButton(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "backButton-component"
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    className: (0, _classnames["default"])(props.separator && "separator", props.className),
    to: props.path
  }, /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
    name: "glyph-arrow"
  }), props.text));
};

exports.BackButton = BackButton;
BackButton.Proptypes = {
  path: _propTypes["default"].string,
  text: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].string, _propTypes["default"].number]),
  separator: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object
};
BackButton.defaultProps = {
  path: "",
  text: "",
  separator: true,
  className: "",
  style: {}
};
var _default = BackButton;
exports["default"] = _default;